export enum MotorStatus {
  MOTOR_STATUS_NOT_READY = 0,
  MOTOR_STATUS_DEFAULT_DATA_SEND = 1,
  MOTOR_STATUS_READY = 2,
  MOTOR_STATUS_RUNNING = 3,
  MOTOR_STATUS_STARTING = 4,
  MOTOR_STATUS_STOPPING = 5,
  MOTOR_STATUS_STOPPED = 6,
  MOTOR_STATUS_ERROR = 7,
  MOTOR_STATUS_OVER_TEMP = 8,
  MOTOR_STATUS_IDLE = 9
}

export const getMotorStatusText = (status: number): string => {
  switch (status) {
    case MotorStatus.MOTOR_STATUS_NOT_READY:
      return "Motor Not Ready";
    case MotorStatus.MOTOR_STATUS_DEFAULT_DATA_SEND:
      return "";
    case MotorStatus.MOTOR_STATUS_READY:
      return "Motor Ready";
    case MotorStatus.MOTOR_STATUS_RUNNING:
      return "Motor Running";
    case MotorStatus.MOTOR_STATUS_STARTING:
      return "Motor Starting";
    case MotorStatus.MOTOR_STATUS_STOPPING:
      return "Motor Stopping";
    case MotorStatus.MOTOR_STATUS_STOPPED:
      return "Motor Stopped";
    case MotorStatus.MOTOR_STATUS_ERROR:
      return "Motor Error";
    case MotorStatus.MOTOR_STATUS_OVER_TEMP:
      return "Motor Over Temp";
    case MotorStatus.MOTOR_STATUS_IDLE:
      return "Motor Stopped";
    default:
      return "Unknown Status";
  }
};

export const getMotorStatusColor = (status: number): string => {
  switch (status) {
    case MotorStatus.MOTOR_STATUS_RUNNING:
      return "text-green-500"; // 运行状态 - 绿色
    case MotorStatus.MOTOR_STATUS_STARTING:
      return "text-yellow-500"; // 启动中 - 黄色
    case MotorStatus.MOTOR_STATUS_READY:
      return "text-blue-500"; // 就绪状态 - 蓝色
    case MotorStatus.MOTOR_STATUS_STOPPING:
      return "text-yellow-500"; // 停止中 - 黄色
    case MotorStatus.MOTOR_STATUS_STOPPED:
    case MotorStatus.MOTOR_STATUS_IDLE:
      return "text-red-500"; // 停止状态 - 红色
    case MotorStatus.MOTOR_STATUS_ERROR:
    case MotorStatus.MOTOR_STATUS_OVER_TEMP:
      return "text-red-600"; // 错误状态 - 深红色
    case MotorStatus.MOTOR_STATUS_NOT_READY:
      return "text-gray-500"; // 未就绪 - 灰色
    default:
      return "text-gray-500"; // 默认 - 灰色
  }
};

export const isMotorRunning = (status: number): boolean => {
  return status === MotorStatus.MOTOR_STATUS_RUNNING || status === MotorStatus.MOTOR_STATUS_STARTING;
};